// extracted by mini-css-extract-plugin
module.exports = {"packShot":"productCardGallery_packShot__h6sdl"};